package com.gloopgo.game.viewmodel

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.gloopgo.game.engine.LeaderboardEntry
import com.gloopgo.game.network.MultiplayerRepository
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.flow.catch
import kotlinx.coroutines.flow.launchIn
import kotlinx.coroutines.flow.onEach
import kotlinx.coroutines.launch

data class LeaderboardUiState(
    val isLoading: Boolean = true,
    val entries: List<LeaderboardEntry> = emptyList(),
    val errorMessage: String? = null,
    val currentUserId: String? = null
)

class LeaderboardViewModel(
    private val repository: MultiplayerRepository
) : ViewModel() {

    private val _uiState = MutableStateFlow(LeaderboardUiState())
    val uiState: StateFlow<LeaderboardUiState> = _uiState.asStateFlow()

    private var leaderboardJob: Job? = null

    init {
        loadLeaderboard()
        viewModelScope.launch {
            val uid = runCatching { repository.getCurrentUserId() }.getOrNull()
            _uiState.update { it.copy(currentUserId = uid) }
        }
    }

    fun loadLeaderboard() {
        leaderboardJob?.cancel()
        leaderboardJob = repository.observeLeaderboard(limit = 20)
            .catch { e ->
                _uiState.update {
                    it.copy(
                        isLoading = false,
                        entries = emptyList(),
                        errorMessage = e.message
                    )
                }
            }
            .onEach { list ->
                _uiState.update {
                    it.copy(
                        isLoading = false,
                        entries = list,
                        errorMessage = null
                    )
                }
            }
            .launchIn(viewModelScope)
    }
}
